// Vite entry point
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@ant-design/v5-patch-for-react-19';
import App from '@app/App';
import '@/main.css';

if (typeof document !== 'undefined') {
    const faviconLink = document.querySelector("link[rel='icon']");
    if (faviconLink) {
        faviconLink.setAttribute('href', '/favicon.png');
    }
}

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
